// @ts-nocheck
import React from 'react';

const strengthLevels = [
  {
    label: 'Fraca',
    textClass: 'text-red-600',
    barClass: 'bg-red-500',
  },
  {
    label: 'Razoável',
    textClass: 'text-amber-600',
    barClass: 'bg-amber-500',
  },
  {
    label: 'Boa',
    textClass: 'text-emerald-600',
    barClass: 'bg-emerald-500',
  },
  {
    label: 'Forte',
    textClass: 'text-green-cl',
    barClass: 'bg-green-cl',
  },
];

const PasswordStrengthIndicator = ({ password = '' }) => {
  const checks = [
    password.length >= 8,
    /[a-z]/.test(password) && /[A-Z]/.test(password),
    /\d/.test(password),
    /[^A-Za-z0-9]/.test(password),
  ];

  const score = checks.filter(Boolean).length;
  const level = strengthLevels[Math.max(0, score - 1)];

  if (!password) {
    return (
      <div className="rounded-xl border border-gray-200 bg-gray-50 px-4 py-3">
        <p className="text-xs leading-5 text-gray-500">
          Utilize pelo menos 8 caracteres. Combine maiúsculas, minúsculas, números e símbolos.
        </p>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-gray-200 bg-gray-50 px-4 py-3">
      <div className="flex items-center justify-between gap-3">
        <span className="text-xs font-semibold text-gray-500">Segurança da palavra-passe</span>
        <span className={`text-xs font-extrabold ${level.textClass}`}>{level.label}</span>
      </div>

      <div className="mt-3 grid grid-cols-4 gap-2" aria-hidden="true">
        {[0, 1, 2, 3].map((segment) => (
          <span
            key={segment}
            className={`h-1.5 rounded-full ${segment < score ? level.barClass : 'bg-gray-200'}`}
          />
        ))}
      </div>

      <p className="mt-2 text-xs leading-5 text-gray-500">
        {score < 4
          ? 'Reforce a palavra-passe adicionando os elementos em falta.'
          : 'A palavra-passe cumpre todos os critérios recomendados.'}
      </p>
    </div>
  );
};

export default PasswordStrengthIndicator;
